// extracted by mini-css-extract-plugin
module.exports = {"logo":"offer-show_logo_1PPzf"};